var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxRefund(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75152H13.125C13.8212 9.75152 14.4889 10.0281 14.9812 10.5204C15.4734 11.0127 15.75 11.6803 15.75 12.3765C15.75 13.0727 15.4734 13.7404 14.9812 14.2327C14.4889 14.725 13.8212 15.0015 13.125 15.0015H12M8.25 9.75152L10.5 7.50152M8.25 9.75152L10.5 12.0015M19.5 4.75852V21.7515L15.75 20.2515L12 21.7515L8.25 20.2515L4.5 21.7515V4.75852C4.5 3.65052 5.306 2.70152 6.407 2.57352C10.1232 2.14216 13.8768 2.14216 17.593 2.57352C18.693 2.70152 19.5 3.65052 19.5 4.75852Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxRefund);
export default __webpack_public_path__ + "static/media/tx_refund.24da065b06962a4bcbd6b65e4aa98ea8.svg";
export { ForwardRef as ReactComponent };